<div
  *transloco="let t"
  class="flex flex-col bg-white border border-surface-subtle rounded-lg overflow-hidden max-h-80 lg:max-h-[calc((100dvh-15.5rem)*2/3)]"
>
  <!-- Tab Bar -->
  <div class="bg-surface-card border-b border-surface-subtle flex gap-3 items-center px-4 py-3 shrink-0">
    @for (tab of tabs(); track tab.key) {
    <button
      (click)="activeTab.set(tab.key)"
      class="flex items-center gap-2 border-b-2 p-1 cursor-pointer transition-colors"
      [class]="activeTab() === tab.key ? 'border-primary' : 'border-transparent'"
    >
      <span
        class="text-xs capitalize"
        [class]="activeTab() === tab.key ? 'font-semibold text-primary' : 'font-medium text-ink-muted'"
      >
        {{ t(tab.labelKey) }}
      </span>
      @if (activeTab() === tab.key) {
      <dss-libs-ui-chip [label]="tab.count | translocoDecimal" [isKeyTranslated]="true" color="primary" />
      }
    </button>
    }
  </div>

  <!-- Signers / Reviewers List -->
  @if (activeTab() !== DetailsTab.Receivers) { @let list = activeTab() === DetailsTab.Signers ? signers() : reviewers();
  <div class="flex-1 min-h-0" dssLibsUiAutoHideScrollbar>
    @for (signer of list; track signer.id) {
    <dss-libs-feature-signer-card
      [signer]="signer"
      [expiryDate]="expiryDate()"
      [daysRemaining]="daysRemaining()"
      [sendingReminderForId]="sendingReminderForId()"
      [canSendReminder]="canSendReminder()"
      [isLast]="$last"
      (sendReminder)="sendReminder.emit($event)"
    />
    }
  </div>

  } @else {
  <!-- Receivers List -->
  <div class="flex-1 min-h-0" dssLibsUiAutoHideScrollbar>
    @for (receiver of receivers(); track receiver.email) {
    <div class="flex items-center gap-2.5 p-3.5 border-surface-subtle" [class.border-b]="!$last">
      <div class="flex size-8.5 shrink-0 items-center justify-center rounded-full bg-primary-ghost">
        <span class="text-xs font-semibold text-primary">{{ receiver.name | initials }}</span>
      </div>
      <div class="flex min-w-0 flex-1 flex-col gap-1">
        <span class="truncate text-sm font-semibold text-ink">{{ receiver.name }}</span>
        <span class="truncate text-xs text-ink-muted">{{ receiver.email }}</span>
      </div>
    </div>
    }
  </div>
  }
</div>
